/* eslint-disable react/prop-types */
import React, {useMemo, useEffect, useState, useRef} from 'react';
import moment from 'moment';
import {useParams, useHistory} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';

import {useReactToPrint} from 'react-to-print';
// import PrintIcon from '../../../../../../../../assets/icons/print-icon.svg';
// import ExcelIcon from '../../../../../../../../assets/icons/excel-icon.svg';
import ArrowLeftImg from '../../../../../../../../assets/icons/arrow_left.svg';
import {
  classesSelector,
  getAssessmentSummaryData,
} from '../../../../../../../../redux/classesSlice';
import {AssessmentSummaryContainer} from './elements';

import {
  GeneralSection,
  AssessmentSection,
  TasksSection,
  StudentsSection,
  EvaluationSection,
} from './components';

import {
  ExportSpreadSheetButton,
  PrintAssessmentSummary,
} from '../../../../../../../Stream/pages/Assesments/AssessmentView/components/AssessmentSummary/components';

export const AssessmentSummary = () => {
  const {orgClassId} = useParams();
  const [orgUnitInstanceId, setOrgUnitInstanceId] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const {assessmentSummary} = useSelector(classesSelector);
  const {
    location: {pathname},
  } = useHistory();

  const assessment = useMemo(
    () => [
      {
        assessmentDescription: assessmentSummary?.ac_activity_description,
        studentInstruction: assessmentSummary?.ac_student_instructions,
        resourceRequired: assessmentSummary?.ac_resource_required,
      },
    ],
    [assessmentSummary],
  );
  const assesmentTasks = useMemo(
    () => assessmentSummary?.tasks,
    [assessmentSummary],
  );

  const studentsInUnits = useMemo(
    () => [
      {
        students: assessmentSummary?.instance?.students,
        totalStudentsInUnit: assessmentSummary?.instance?.totalStudents,
      },
    ],
    [assessmentSummary],
  );
  const studentsSubmission = useMemo(() => {
    const result = {};
    assessmentSummary?.tasks?.forEach(item => {
      if (Object.keys(item?.performanceCriteria || {}).length) {
        item.submissions.forEach(submission => {
          result[submission.up_id_userprofile] = submission;
        });
      }
    });
    return Object.values(result);
  }, [assessmentSummary]);

  useEffect(() => {
    const assessmentId = pathname.split('/')[8];
    dispatch(getAssessmentSummaryData(assessmentId));
    const unitId = pathname.split('/')[6];
    setOrgUnitInstanceId(unitId);
  }, [dispatch, orgClassId, pathname]);

  const componentRef = useRef();

  const pageStyle = `
  @page {
    size: A4;
    margin: 11mm 17mm 17mm 17mm;
  }
  
  @media print {
    footer {
      position: fixed;
      bottom: 0;
    }
  
    .content-block, p {
      page-break-inside: avoid;
    }
  
    html, body {
      width: 210mm;
      height: 297mm;
    }
  }
`;
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle,
  });

  return (
    <AssessmentSummaryContainer>
      <div className="back-button">
        <button
          className="btn"
          onClick={() =>
            history.replace(
              `/admin/classes/view-class/${orgClassId}/units/${orgUnitInstanceId}/assessments`,
            )
          }
          style={{
            padding: 0,
          }}
          type="button"
        >
          <img src={ArrowLeftImg} alt="arrow" />
          <span>Back</span>
        </button>
      </div>
      <div className="overview-data">
        <div className="overview-left">
          <div>
            <h2 className="assessment-title">
              {assessmentSummary?.ac_activity_name}
            </h2>
            <p className="time">
              {moment(assessmentSummary?.aoui_timestamp_creation).format(
                'Do MMM YYYY',
              )}
            </p>
          </div>
        </div>
        <div className="overview-right">
          <div className="teacher-info">
            <p className="created-by">Created by</p>
            <span className="teacher-name">
              {`${assessmentSummary?.up_name_first} ${assessmentSummary?.up_name_last}`}
            </span>
          </div>
          <div className="firstlast-teacher">
            <div className="teacher-logo">
              {`${assessmentSummary?.up_name_first[0]}${assessmentSummary?.up_name_last[0]}`}
            </div>
          </div>
        </div>
      </div>
      <div className="header-container">
        <div>
          <div className="header">
            Summary
            <div className="seperator" />
          </div>
        </div>
        <div className="button-container">
          <ExportSpreadSheetButton assessmentSummary={assessmentSummary} />
          <PrintAssessmentSummary handlePrint={handlePrint} />
        </div>
      </div>
      <div ref={componentRef}>
        <GeneralSection assessmentSummary={assessmentSummary} />
        <AssessmentSection assessment={assessment} />
        <TasksSection assesmentTasks={assesmentTasks} />
        <StudentsSection
          students={studentsInUnits}
          studentsSubmission={studentsSubmission}
        />
        <EvaluationSection assessmentSubmission={assessmentSummary?.instance} />
      </div>
    </AssessmentSummaryContainer>
  );
};
